import { render, staticRenderFns } from "./limitDiscount.vue?vue&type=template&id=ce7f7774&"
import script from "./limitDiscount.vue?vue&type=script&lang=ts&"
export * from "./limitDiscount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports